module.exports = __webpack_public_path__ + "media/images/athletes/1738-db621ca82f1d872dfaaf8747ffe27fef.png";